export const INTEGRACAO_COMERCIAL_PAGES = [
    { label: 'Preparar envio', icon: 'pi pi-filter', path: '/dashboard/funil-vendas/previa' },
    { label: 'Contratos IntraConnect', icon: 'pi pi-file', path: '/dashboard/funil-vendas/contratos' },
    { label: 'Histórico de envios', icon: 'pi pi-history', path: '/dashboard/funil-vendas/historico' },
    { label: 'Tags', icon: 'pi pi-tag', path: '/dashboard/funil-vendas/tags' }
];
